var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone_Icon",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    className: "st0",
    d: "M10.8,16.4c1.9,3.8,5,6.9,8.8,8.8l2.9-2.9c0.4-0.4,0.9-0.5,1.4-0.3c1.5,0.5,3.1,0.8,4.8,0.8 c0.7,0,1.3,0.6,1.3,1.3c0,0,0,0,0,0v4.7c0,0.7-0.6,1.3-1.3,1.3c0,0,0,0,0,0C16.1,30,6,19.9,6,7.3c0,0,0,0,0,0C6,6.6,6.6,6,7.3,6h0 H12c0.7,0,1.3,0.6,1.3,1.3c0,0,0,0,0,0c0,1.6,0.3,3.2,0.8,4.8c0.2,0.5,0,1-0.3,1.4L10.8,16.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone (1).808dd4fa48efbdacf174bc52600a77be.svg";
export { ForwardRef as ReactComponent };